import moment from 'moment';
import { LanguageService, ModelService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { ISO_HOURS_MINUTES_FORMAT } from '@philips-internal/oswald-ui-model/lib/formatters/date/date-utils.js';
import { isContentfulString, isUndefined } from '@philips-internal/oswald-ui-utils';
import { TimeFieldFormat, TimeFieldMode } from './time-field-constants.js';
function formatTime(value) {
    const { hours, minutes, timeMode } = value;
    const time = `${hours}:${minutes}`;
    const inputFormat = TimeFieldFormat.DEFAULT;
    const outputFormat = timeMode === TimeFieldMode.TWELVE_HOURS ? TimeFieldFormat.WITH_PERIOD : TimeFieldFormat.DEFAULT;
    return moment(time, inputFormat).format(outputFormat);
}
function formatTimeNumber(value) {
    return String(value).padStart(2, '0');
}
function normalizeUTCShortTime(time) {
    if (!isContentfulString(time)) {
        return '';
    }
    const values = time.replace('Z', '').split(':');
    if (values.length < 2) {
        throw new Error('[Time Field] Invalid value format provided.');
    }
    const hours = formatTimeNumber(values[0]);
    const minutes = formatTimeNumber(values[1]);
    return `${hours}:${minutes}Z`;
}
function toLocalShortTime(time) {
    if (!isContentfulString(time)) {
        return '';
    }
    return ModelService.format('date', normalizeUTCShortTime(time), { type: 'shortTime' });
}
function toUTCShortTime(time, timeMode) {
    if (!isContentfulString(time)) {
        return '';
    }
    const inputFormat = timeMode === TimeFieldMode.TWELVE_HOURS ? TimeFieldFormat.WITH_PERIOD : TimeFieldFormat.DEFAULT;
    return moment(time, inputFormat).utc().format(ISO_HOURS_MINUTES_FORMAT);
}
function getTimeMode() {
    const language = LanguageService.getCurrentLanguage();
    const { hour12 } = Intl.DateTimeFormat(language, { hour: 'numeric' }).resolvedOptions();
    return hour12 ? TimeFieldMode.TWELVE_HOURS : TimeFieldMode.TWENTY_FOUR_HOURS;
}
function getValueFromInternalValue(internalValue) {
    if (isUndefined(internalValue)) {
        return '';
    }
    const isArray = Array.isArray(internalValue);
    const timeMode = getTimeMode();
    if (!isArray) {
        if (!isContentfulString(internalValue)) {
            return '';
        }
        return toUTCShortTime(internalValue, timeMode);
    }
    if (!internalValue.length) {
        return [];
    }
    return internalValue.map((time) => toUTCShortTime(time, timeMode));
}
export { formatTime, formatTimeNumber, getTimeMode, getValueFromInternalValue, normalizeUTCShortTime, toLocalShortTime, toUTCShortTime, };
//# sourceMappingURL=time-field-utils.js.map